import { StatusColor } from '../../common/enums.js';
import {
  acceptedMsg,
  eurosPerMonthCapMsg,
  pcsMsg,
  rejectedMsg,
  statusMsg,
  t,
  waitingForProcessingMsg,
} from '../../common/i18n/index.js';
import { QuoteStatusType } from '../../generated/api/quoteStatusType.js';
import { PriceType } from '../HorizontalSubscriptionCard/types.js';
import type { PriceDetail } from '../../generated/api/priceDetail.js';
import type { SearchFilterGroup } from '../Table/SearchFilters.js';

export interface QuoteStatus {
  color: StatusColor;
  text: string;
}

export const getQuoteStatus = (status: QuoteStatusType): QuoteStatus => {
  switch (status) {
    case QuoteStatusType.APPROVED: {
      return {
        color: StatusColor.ORANGE,
        text: t.L7ML(waitingForProcessingMsg),
      };
    }
    case QuoteStatusType.ACCEPTED: {
      return {
        color: StatusColor.GREEN,
        text: t.K8YJ(acceptedMsg),
      };
    }
    case QuoteStatusType.REJECTED: {
      return {
        color: StatusColor.RED,
        text: t.SFI7(rejectedMsg),
      };
    }
    default: {
      return {
        color: StatusColor.GREY,
        text: '',
      };
    }
  }
};

export const getQuoteStatusFilterGroup = (selectedStatus: string = ''): SearchFilterGroup => {
  const enabledStatuses = selectedStatus ? selectedStatus.split('|') : [];

  return {
    label: () => t.ASQT(statusMsg),
    value: 'status',
    items: [
      {
        label: () => t.L7ML(waitingForProcessingMsg),
        value: QuoteStatusType.APPROVED,
        checked: enabledStatuses.includes(QuoteStatusType.APPROVED),
      },
      {
        label: () => t.SFI7(rejectedMsg),
        value: QuoteStatusType.REJECTED,
        checked: enabledStatuses.includes(QuoteStatusType.REJECTED),
      },
      {
        label: () => t.K8YJ(acceptedMsg),
        value: QuoteStatusType.ACCEPTED,
        checked: enabledStatuses.includes(QuoteStatusType.ACCEPTED),
      },
    ],
  };
};

export const getMonthlyCharges = (prices: PriceDetail[], quantity: number): string => {
  if (prices != null) {
    const total = prices.reduce((sum, price) => {
      if (price == null || price.amount == null) {
        return sum;
      }
      return price.type === PriceType.RECURRING_CHARGE ? sum + price.amount * quantity : sum;
    }, 0);
    return total === 0 ? '' : `${total} ${t.H37G(eurosPerMonthCapMsg)}`;
  }
  return '';
};

export const getOneTimeCharges = (prices: PriceDetail[], quantity: number): string => {
  if (prices != null) {
    const total = prices.reduce((sum, price) => {
      if (price == null || price.amount == null) {
        return sum;
      }
      return price.type === PriceType.ONE_TIME_CHARGE ? sum + price.amount * quantity : sum;
    }, 0);
    return total === 0 ? '' : `${total} €`;
  }
  return '';
};

export const getQuantity = (quantity: number) => {
  return quantity + ` ${t.B3MG(pcsMsg)}`;
};
